import React from 'react';
import { useParams } from 'react-router-dom';
import './Coupon.css';

const Coupon = () => {
  const { couponCode } = useParams();

  const handleDownload = () => {
    // Simulate downloading the coupon as an image
    const link = document.createElement('a');
    link.href = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${couponCode}`;
    link.download = `coupon-${couponCode}.png`;
    link.click();
  };

  return (
    <div className="coupon-container">
      <h2>Your Coupon is Ready!</h2>
      <div className="coupon-card">
        <h3>Coupon Code: {couponCode}</h3>
        <img
          src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${couponCode}`}
          alt="Coupon QR Code"
          className="coupon-qr"
        />
        <p>Present this code or QR at the merchant to redeem your offer.</p>
        <button className="download-btn" onClick={handleDownload}>
          Download Coupon
        </button>
      </div>
    </div>
  );
};

export default Coupon;